import { useState } from "react";
import { convertToDateString } from "../../../Helpers";
import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";

const postPaymentsFields = (myForm, isEdit = false) => {
  myForm.addCenteredGroup([myForm.getDropdownField("Borrower", "metadata/list-borrower-organizations", { 
    name: "borrowerOrganizationId", 
    required: true,
    disabled: isEdit
  })]);

  myForm.addCenteredGroup([myForm.getDropdownField("Bank Organization", "bankaccount/list-banks", {
    name: "bankOrganizationId",
    required: true
  }),]);
  
  myForm.addCenteredGroup([myForm.getCalendarField("Received Date", { isDefaultDateNow: true, name: "receivedDate", required: true })]);
  myForm.addCenteredGroup([myForm.getInputField("Received Amount", { fieldType: "dollar", required: true, name:"receivedAmount" })]);
  myForm.addCenteredGroup([
    myForm.getLabelField("Wire Or Check", { width: 2 }),
    myForm.getGroupRadioField("Portal", { value: "P" }),
    myForm.getGroupRadioField("Wire", { value: "W" }),
    myForm.getGroupRadioField("Check", { value: "C" }),
  ],{ radioGroupName: "wireOrCheck", radioGroupValue: "W" }); 

  myForm.addCenteredGroup([myForm.getInputField("Check Number", {
    name:"CheckNumber",
    required: { wireOrCheck: "C" }
  }),], { isHidden: { wireOrCheck: "C" }, isHiddenOperation: "notequal"});

  return myForm;
};

const editPostPaymentsFields = (myForm, postPaymentTempId) => {
  myForm.addCenteredGroup([
    myForm.getCurrencyField("Principal Amount"),
    myForm.getDropdownField("Principal Loan", postPaymentTempId ? `payment/${postPaymentTempId}/list-principal-loan` : "", { required: true, name: "principalLoanId" })
  ]);

  myForm.addCenteredGroup([myForm.getTextareaField("Comments", { name: "description" })]);
  myForm.addDividerField({ dividerIsHidden: true });
  myForm.addGroupFields([
    myForm.getLabelField("", { width: 1 }),
    myForm.getLabelField("Loan", { position: "center", width: 2 }),
    myForm.getLabelField("Owner", { position: "center", width: 2 }),
    myForm.getLabelField("Transaction Category", { position: "center", width: 2, wrapLabel: true }),
    myForm.getLabelField("Transaction Type", { position: "center", width: 2, wrapLabel: true }),
    myForm.getLabelField("Effective Date", { position: "center", width: 2  }),
    myForm.getLabelField("Due Date", { position: "center", width: 2, wrapLabel: true }),
    myForm.getLabelField("Transaction Amount", { position: "center", width: 3 }),
    myForm.getLabelField("Current Outstanding Amount", { wrapLabel: true, position: "center", width: 3  }),
    myForm.getLabelField("Payment Amount", { position: "center", width: 2,  }),
    myForm.getLabelField("Outstanding After Payment", { position: "center", width: 3, wrapLabel: true }),
    myForm.getLabelField("Comments", { position: "center", width: 2 }),
  ], { widths: 1 });

  if (myForm?.initialValues?.loanPaymentTempDetails?.length) {
    let totalPaymentAllocated = 0;
    myForm.initialValues.loanPaymentTempDetails.map((rowData, i) => {
      const {
        loanDisplay,
        ownerDisplay,
        transactionCategoryDisplay,
        transactionTypeDisplay,
        transactionEffectiveDate,
        transactionDueDate,
        transactionAmount,
        outstandingAmount,
        paymentAmount,
        description,
        paymentAmountDisabled,
        color
      } = rowData;
      totalPaymentAllocated += paymentAmount;
      myForm.addGroupFields([
        myForm.getCheckboxField("", { label: "", name: "checkbox", nestedInputsProp: i, width: 1 }),
        myForm.getLabelField(loanDisplay || "", { width: 2, position: "center" }),
        myForm.getLabelField(ownerDisplay || "", { width: 2, position: "center" }),
        myForm.getLabelField(transactionCategoryDisplay || "", { width: 2, wrapLabel: true, position: "center" }),
        myForm.getLabelField(transactionTypeDisplay || "", { width: 2, wrapLabel: true, position: "center" }),
        myForm.getLabelField(convertToDateString(transactionEffectiveDate) || "", { width: 2, position: "center" }),
        myForm.getLabelField(convertToDateString(transactionDueDate) || "", { width: 2, position: "center" }),
        myForm.getCurrencyField("", { name: "transactionAmount", value: transactionAmount, disabled: true, nestedInputsProp: i, width: 3, noBackground: true }),
        myForm.getCurrencyField("", { name: "outstandingAmount", value: outstandingAmount, disabled: true, nestedInputsProp: i, width: 3, noBackground: true }),
        myForm.getCurrencyField("", { 
          name: "paymentAmount",  
          calculatedTargetField: "totalPayment", 
          disabled: paymentAmountDisabled, 
          value: paymentAmount, 
          nestedInputsProp: i, 
          width: 2,
          isDisabledOn: { checkbox: true }, 
          isDisabledOnOperation: "notequal"
        }),
        myForm.getCurrencyField("", { name: "outstandingAfterPayment", value: outstandingAmount - paymentAmount, nestedInputsProp: i, disabled: true, width: 3, noBackground: true }),
        myForm.getInputField("", { name: "description", value: description, nestedInputsProp: i, width: 2, wrapLabel: true }),       
      ], { widths: 1, groupStyles: { backgroundColor: color } });
    });

    myForm.addGroupFields([myForm.getCurrencyField("Total Payment Allocated", { value: totalPaymentAllocated, width: 5, inline: true, alignRight: true, disabled: true }),]);
  }
};

const AddPostPaymentsForm = () => {
  const myForm = new BCFormController({}, { 
    submitSuffix: "payment/post-payment", 
    blankWidth: 4,
    dataFormatterFunc: (data) => { return {...data, paymentOption: "Multiple Payment"}; },
    onSubmitSuccess: (response, options) => options.history.push(`accounting-post-payments/${response?.id}`)
  });

  postPaymentsFields(myForm);
  return (
    <LmsFormGenerator
      myForm={myForm}
      actions={[{ text: "Submit", action: "save" }, "close" ]}
    />
  );
};

const EditPostPaymentsForm = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`payment/post-payment/${id}`);
  const [inputsCopy, setInputsCopy] = useState(undefined as any);
  const postPaymentsDataFormatterFunc = (inputs) => {
    const loanTempData = [] as any;
    data?.loanPaymentTempDetails?.map((item: any, i) => {
      loanTempData.push({
        ...item,
        paymentAmount: parseFloat(inputs[i]?.paymentAmount),
        outstandingAmount: inputs[i]?.outstandingAmount,
        description: inputs[i]?.description || "",
      });
    });

    const inputValues = {
      bankOrganizationId: inputs?.bankOrganizationId,
      borrowerOrganizationId: inputs?.borrowerOrganizationId,
      receivedAmount: inputs?.receivedAmount,
      paymentOption: "Multiple Payment",
      principalAmount: inputs?.principalAmount,
      principalLoanId: inputs?.principalLoanId,
      wireOrCheck: inputs?.wireOrCheck,
      receivedDate: inputs?.receivedDate,
      description: inputs?.description,
    };

    return {
      ...inputValues,
      id: id,
      loanPaymentTempDetails: loanTempData,
    };
  };

  const myForm = new BCFormController(data, { 
    submitSuffix: "payment/post-payment", 
    submitMethod: "PUT",
    blankWidth: 4,
    onSubmitSuccess: (_, options) => options.history.push("/accounting-post-payments"),
    dataFormatterFunc: (data) => postPaymentsDataFormatterFunc(data),
    styles: { minWidth: "2000px" },
    isCompact: true
  });

  postPaymentsFields(myForm, true);
  editPostPaymentsFields(myForm, id);
  const onPostPaymentsChanged = async (options, lastUpdated, nestedProp) => {
    const inputs = options?.inputs || {};
    const nestedPropCopy = { ...inputs[nestedProp] };
    if (lastUpdated === "checkbox") {
      if (nestedPropCopy.checkbox === true) {
        nestedPropCopy.paymentAmountDisabled = false;
        nestedPropCopy.paymentAmount = nestedPropCopy.outstandingAmount;
      }
      else {
        nestedPropCopy.paymentAmount = "";
      }
    }

    nestedPropCopy.paymentAmountDisabled = !nestedPropCopy.checkbox;
    nestedPropCopy.outstandingAfterPayment = nestedPropCopy.outstandingAmount - nestedPropCopy.paymentAmount;
    
    let totalPayment = 0;
    const updatedInput = { ...inputs, [nestedProp]: nestedPropCopy};
    for (const property in updatedInput) {
      if (typeof updatedInput[property] === "object" && updatedInput[property]?.paymentAmount) {
        totalPayment += parseFloat(updatedInput[property]?.paymentAmount);
      }
    }

    totalPayment += updatedInput.principalAmount ? parseFloat(updatedInput.principalAmount) : 0;
    setInputsCopy({ ...updatedInput, totalPaymentAllocated: totalPayment});
  };

  const handleSubmitValidation = async ( inputs ) => {
    const message = [] as string[];
    const totalPaymentAllocated = inputs.totalPaymentAllocated ? parseFloat(inputs.totalPaymentAllocated) : 0;
    if (inputs.receivedAmount !== totalPaymentAllocated) {
      message.push("Total Payment Allocated must be equal to Received Amount.");
    }

    if (!inputs.principalLoanId || inputs?.principalLoanId.includes("00000000")) {
      message.push("The Principal Loan field is required.");
    }

    if (message?.length) {
      return { errorMessage: message };
    }
    else {
      return { success: true };
    }
  };

  return <LmsFormGenerator 
      myForm={myForm} 
      isLoading={isLoading} 
      error={error} 
      actions={[{ text: "Submit", action: "save" }, "close" ]}
      onFormChanged={onPostPaymentsChanged}
      handleSubmitValidation={handleSubmitValidation}
      inputs={inputsCopy}
      onSubmitSuccessMessage={"The form was submitted successfully."}
    />;
};

const LmsAccountingPostPayments = ({ params = {}, history }) => {
  const { isMainPage, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<>
    {isMainPage && <AddPostPaymentsForm />}
    {isEdit && <EditPostPaymentsForm id={id}/>}
  </>);
};

export default LmsAccountingPostPayments;